import { render, staticRenderFns } from "./ApplicationValueDisplay.vue?vue&type=template&id=852d7e20&scoped=true&"
import script from "./ApplicationValueDisplay.vue?vue&type=script&lang=js&"
export * from "./ApplicationValueDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationValueDisplay.vue?vue&type=style&index=0&id=852d7e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852d7e20",
  null
  
)

export default component.exports